import { useState } from "react";
import { RELEASE } from "../../constants/testIds";

function fmt(s) {
  s = Math.max(0, Math.floor(s || 0));
  return Math.floor(s / 60) + ":" + String(s % 60).padStart(2, "0");
}

export const PlayerBar = ({ titles, playlistIndex, videoId, playing, currentTime, duration, onPlayPause, onNext, onPrev, onSeek, spotifyUrl, ytMusicUrl, onOutbound }) => {
  const meta = titles[playlistIndex % titles.length] || {};
  const pct = duration ? (currentTime / duration) * 100 : 0;
  const discStyle = videoId
    ? { backgroundImage: `radial-gradient(circle,transparent 55%,rgba(10,14,40,.45)),url(https://i.ytimg.com/vi/${videoId}/hqdefault.jpg)` }
    : undefined;
  const [ripple, setRipple] = useState({ spotify: false, ytmusic: false });

  const fireOutbound = (dest) => {
    onOutbound(dest);
    setRipple((r) => ({ ...r, [dest]: true }));
    setTimeout(() => setRipple((r) => ({ ...r, [dest]: false })), 700);
  };

  const handleSeekClick = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    onSeek(((e.clientX - r.left) / r.width) * (duration || 0));
  };

  return (
    <div id="player" className={playing ? "playing" : ""}>
      <div id="disc" style={discStyle}></div>
      <div className="pm">
        <div className="t" data-testid={RELEASE.nowTitle}>{meta.t || "—"}</div>
        <div className="a" data-testid={RELEASE.nowArtist}>{meta.a || ""}</div>
        <div className="seekrow">
          <div id="seek" data-testid={RELEASE.seekBar} style={{ "--p": `${pct}%` }} onClick={handleSeekClick}>
            <div className="rail"><div className="fill"></div><div className="dotk"></div></div>
          </div>
          <div className="time">{fmt(currentTime)} / {fmt(duration)}</div>
        </div>
      </div>
      <div className="ctr">
        <button data-testid={RELEASE.prevButton} className="pbtn" title="Previous" onClick={onPrev}>
          <svg viewBox="0 0 24 24"><path d="M6 6h2v12H6zm3.5 6l8.5 6V6z" /></svg>
        </button>
        <button data-testid={RELEASE.playButton} className="pbtn" id="playBtn" title="Play / Pause" onClick={onPlayPause}>
          <svg viewBox="0 0 24 24">
            {playing ? <path d="M6 5h4v14H6zm8 0h4v14h-4z" /> : <path d="M8 5v14l11-7z" />}
          </svg>
        </button>
        <button data-testid={RELEASE.nextButton} className="pbtn" title="Next" onClick={onNext}>
          <svg viewBox="0 0 24 24"><path d="M16 6h2v12h-2zm-2.5 6L5 18V6z" /></svg>
        </button>
      </div>
      <div className="outs">
        <a
          data-testid={RELEASE.spotifyLink}
          className={`outbtn sp${ripple.spotify ? " rippling" : ""}`}
          href={spotifyUrl} target="_blank" rel="noopener" title="Save on Spotify" aria-label="Save on Spotify"
          onClick={() => fireOutbound("spotify")}
        >
          <span className="ripple-glow" aria-hidden="true"></span>
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" /></svg>
        </a>
        <a
          data-testid={RELEASE.ytMusicLink}
          className={`outbtn yt${ripple.ytmusic ? " rippling" : ""}`}
          href={ytMusicUrl} target="_blank" rel="noopener" title="YouTube Music" aria-label="Open in YouTube Music"
          onClick={() => fireOutbound("ytmusic")}
        >
          <span className="ripple-glow" aria-hidden="true"></span>
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 1.5A10.5 10.5 0 1 0 22.5 12 10.51 10.51 0 0 0 12 1.5zm0 19A8.5 8.5 0 1 1 20.5 12 8.51 8.51 0 0 1 12 20.5z" /><path d="M9.6 7.8l6.6 4.2-6.6 4.2z" /></svg>
        </a>
      </div>
    </div>
  );
};

